const colors = {
  beige: '#FCF2E8',
  pink: '#DD2C7D',
  black: '#020304',
  white: '#FFFFFF',
}

export default colors
